import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import HistoryListType from "./subPages/HistoryListType";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getHistoryList, getHistoryMenus} from "../../../api/history/HistoryService";
import {COMMON_HISTORY_LIST_HEADER} from "../../../components/table/header/Headers";

function HistoryList(){
    const [checked,setChecked] = useState([]);
    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const [menu, setMenu] = useState();
    useEffect(() => {
        getHistoryMenus().then(response => {
            if(response.data) {
                const list = response.data.map(each => (
                    {id: each[1], name: each[1]}
                ));
                setMenu(list);
            }
        });
    }, [])

    const { newData, pageInfo, dataHook, getQr} =
        useRequestData((conditions, pageable) => {
            const additionalCondition = {
                historyType: conditions.historyType || 'A'
            };
            const finalConditions = {
                ...conditions,
                ...additionalCondition
            };
            return getHistoryList(finalConditions, pageable);
        }, initDate, "all_history");

    return (
        <>
            <div className="common-container">
                <PageHeader header={"전체이력관리"} indicator={"환경설정 > 전체이력관리"}/>
                <HistoryListType checked={{checked: checked, setChecked: setChecked}}
                                 data={newData} date={initDate} pageInfo={pageInfo}
                                 getQr={getQr}
                                 dataHook={dataHook}
                                 header={COMMON_HISTORY_LIST_HEADER}
                                 menu={menu}
                                 type={"all_history"}
                />

            </div>
        </>
    );
}

export {HistoryList}